import React, { PureComponent } from 'react';
import Slider from 'react-slick';

import './pureSlider.less';
import '../../../lib/slick/slick-theme.less';
import '../../../lib/slick/slick.less';

class PureSlider extends PureComponent {
	render() {
		return (
			<div className="carousel-slider">
				<Slider {...this.props} afterChange={this.props.updateIndex} ref={this.props.sliderRef}>
					{this.props.children}
				</Slider>
			</div>
		);
	}
}

export default PureSlider;



// WEBPACK FOOTER //
// ./src/react/views/carousel/PureSlider.jsx